"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoAnalytics = void 0;
var NPAWAnalytics_1 = require("./NPAWAnalytics");
var videoAnalytics = /** @class */ (function () {
    function videoAnalytics(analyticsConfig) {
        this.analyticsInstance = new NPAWAnalytics_1.NPAWAnalytics(analyticsConfig);
    }
    videoAnalytics.prototype.setup = function (videoAnalyticsConfig) {
        this.analyticsInstance.setup(videoAnalyticsConfig);
    };
    videoAnalytics.prototype.destroy = function () {
        this.analyticsInstance.destroy && this.analyticsInstance.destroy();
    };
    return videoAnalytics;
}());
exports.videoAnalytics = videoAnalytics;
